import React from "react";
import { DataTable } from "./DataTable";
import { Button, message } from "antd";
import { YhBox } from "@/components/YhBox";
import { useDtpModel } from "../dtpModel";
import useNavModel from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/AppResourceAuthEnum";
import { useDtpDetailModel } from "./details/dtpDetailModel";

export const DataBox = () => {
    const { selectedRowKeys, exportDtp, disableDtp } = useDtpModel(({ selectedRowKeys, searchParam }) => [selectedRowKeys, searchParam]);
    const { updateFormVal } = useDtpDetailModel(() => [])
    const { addNav, findNav, selectNav, switchNavState } = useNavModel(() => []);

    const onEdit = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        let enquiryEditKey = "9-2-2";
        let isFindNav = findNav(enquiryEditKey);
        if (!isFindNav) {
            addNav(enquiryEditKey, { id: selectedRowKeys[0], mode: "edit" });
            updateFormVal("edit", null);
        } else {
            globalPrompt("modal", {
                title: "报关跳转详情",
                type: "warning",
                text: "您还有报关详情未保存，是否跳转",
                okText: "跳转未保存页",
                onOk: () => selectNav(isFindNav ? isFindNav.id : ""),
                cancelText: "打开新页签",
                onCancel: () => {
                    switchNavState(enquiryEditKey, { id: selectedRowKeys[0], mode: "edit" });
                    updateFormVal("edit", null);
                }
            })
        }
    }

    const action = <>
        <YhAuth resCode={ResourceAuthEnum.CUS_B_AD}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => addNav("9-2-1", { id: "", mode: "add" })}
            >新增</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.CUS_B_ED}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={onEdit}
            >编辑</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.CUS_B_EX}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => exportDtp()}
            >导出</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.CUS_B_DEL}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => {
                    if (!selectedRowKeys.length) {
                        message.warning("请选择你要作废的单据");
                        return;
                    }
                    globalPrompt("modal", {
                        title: "报关单作废",
                        text: ` `,
                        onOk: () => disableDtp(selectedRowKeys[0]),
                    })
                }}
            >作废</Button>
        </YhAuth>
    </>;

    return (
        <YhBox title="" action={action}>
            <DataTable />
        </YhBox>
    )
}